import service from '@/services/superaccess'
import { client_id, client_secret } from '@/services/config'

const AuthenticationModule = {
  state: {
    logged_in: JSON.parse(localStorage.getItem('logged_in')) || false,
    token_user: localStorage.getItem('token_user') || '',
    user_email: localStorage.getItem('user_email') || '',
    user_data: JSON.parse(localStorage.getItem('user_data')) || [],
    user_shard: JSON.parse(localStorage.getItem('user_shard')) || [],
    local_language: localStorage.getItem('local_language') || '',
    language_change: localStorage.getItem('language_change') || false,
    disconnection: false,
    first_sync: false,
    web_status: false,
    valid_pass: localStorage.getItem('valid_pass') || true
  },
  getters: {
    getFirstSync (state) {
      return state.first_sync
    },
    getStatusConnection (state) {
      return state.disconnection
    },
    dataLoggedIn (state) {
      return state.logged_in
    },
    getUserData (state) {
      return state.user_data
    },
    getUserShard (state) {
      return state.user_shard
    },
    getUserToken (state) {
      return state.token_user
    },
    getUserEmail (state) {
      return state.user_email
    },
    getLocalLanguage (state) {
      return state.local_language
    },
    getLanguageChange (state) {
      return state.language_change
    },
    getUserPermissions (state) {
      let result = {}
      if (state.user_data.profiles) {
        state.user_data.profiles.forEach(elem => {
          if (elem.profile_id === state.user_shard.profile_id) {
            result = elem.permissions
          }
        })
      }
      return result
    },
    getWebStatus (state) {
      return state.web_status
    },
    getValidPass (state) {
      return state.valid_pass
    }
  },
  mutations: {
    setWebStatus (state, status) {
      state.web_status = status
    },
    setFirstSync (state, status) {
      state.first_sync = status
    },
    setStatusConnection (state, status) {
      state.disconnection = status
    },
    setLoggedIn (state, state_log) {
      state.logged_in = state_log
    },
    setToken (state, token) {
      state.token_user = token
    },
    setUserEmail (state, user_email) {
      state.user_email = user_email
    },
    setUserData (state, user_data) {
      state.user_data = user_data
      localStorage.setItem('user_data', JSON.stringify(user_data))
    },
    setUserShard (state, user_shard) {
      state.user_shard = user_shard
      localStorage.setItem('user_shard', JSON.stringify(user_shard))
    },
    setLanguage (state, language) {
      state.user_data.language = language
      localStorage.setItem('user_data', JSON.stringify(state.user_data))
      state.local_language = language
      localStorage.setItem('local_language', language)
    },
    setLocalLanguage (state, local_language) {
      state.local_language = local_language
      localStorage.setItem('local_language', local_language)
    },
    setChangeLaguage (state, change_language) {
      state.language_change = change_language
      localStorage.setItem('language_change', change_language)
    },
    setValidPass (state, isvalid) {
      state.valid_pass = isvalid
    }
  },
  actions: {
    changeLanguageStatus (context, payload) {
      context.commit('setChangeLaguage', payload)
    },
    postLogin (context, payload) {
      // let data = { email: payload[0], password: payload[1], grant_type: 'password', client_id: client_id, client_secret: client_secret }
      return new Promise((resolve, reject) => {
        var hostname = window.location.hostname
        var port = window.location.port
        var url2 = ''
        service.post('api/login', context, payload)
          .then((response) => {
            service.post('api/verify_pass_date', context, { user_email: payload.email, hostname: hostname, port: port })
              .then((res) => {
                if (res.data.status && res.data.status === 101) {
                  localStorage.setItem('valid_pass', false)
                  context.commit('setValidPass', false)
                  url2 = 'https://' + hostname + '/assign-password/' + res.data.id
                  window.location.href = url2
                  // return
                } else {
                  localStorage.setItem('token_user', response.data.access_token)
                  context.commit('setToken', response.data.access_token)
                  context.commit('setWebStatus', response.data.web_status)
                  localStorage.setItem('user_email', payload.email)
                  context.commit('setUserEmail', payload.email)
                  localStorage.setItem('logged_in', true)
                  context.commit('setLoggedIn', true)
                  localStorage.setItem('valid_pass', true)
                  context.commit('setValidPass', true)
                  resolve('200')
                }
              })
              .catch((error) => {
                resolve(error)
              })
          })
          .catch((error) => {
            console.log(error)
            localStorage.setItem('logged_in', false)
            context.state.logged_in = false
            resolve('404')
          })
        // service.post('api/oauth2/token', context, data)
      })
    },
    postLogout (context, payload) {
      let data = { client_id: client_id, client_secret: client_secret, token: context.token_user }
      return new Promise((resolve, reject) => {
        service.post('api/oauth2/revoke', context, data)
          .then((response) => {
            localStorage.setItem('token_user', '')
            context.commit('setToken', '')
            resolve('200')
          })
          .catch((error) => {
            console.log(error)
            resolve('404')
          })
      })
    },
    getUserData (context, payload) {
      return new Promise((resolve, reject) => {
        service.post('api/login/get-data', context, { user_email: payload })
          .then((response) => {
            context.commit('setUserData', response.data)
            resolve(response.status)
          })
          .catch((error) => {
            resolve(error)
          })
      })
    },
    getEditUser (context, payload) {
      delete payload.profiles
      return new Promise((resolve, reject) => {
        service.patch('/api/user/profile/modify', context, payload)
          .then((response) => {
            if (response.data) {
              context.commit('setUserData', response.data.user)
            }
            resolve(response)
          })
          .catch((error) => {
            resolve(error)
          })
      })
    },
    patchChangePassword (context, payload) {
      return service.patch('/api/user/change-password', context, { password: payload })
    },
    getEditLanguage (context, payload) {
      return new Promise((resolve, reject) => {
        service.patch('/api/user/language', context, { language: payload, id: context.getters.getUserData.id })
          .then((response) => {
            if (response.data) {
              context.commit('setLanguage', payload)
            }
            resolve(response)
          })
          .catch((error) => {
            resolve(error)
          })
      })
    },
    postValidateLink (context, payload) {
      return service.post('/api/user/validate-link', context, { id: payload })
    },
    potAssignPassword (context, payload) {
      return service.post('/api/user/assign-password', context, { data: payload })
    },
    postResetPassword (context, payload) {
      return service.post('/api/user/reset-password', context, { email: payload })
    },
    postGetProperties (context, payload) {
      return service.post('/api/user/get-properties', context, { profiles: payload })
    },
    postValidateActivation (context, payload) {
      return service.post('/api/validate/validate-activation', context)
    },
    postActivate (context, payload) {
      return service.post('/api/validate/activate', context, { code: payload })
    },
    firstSync (context, payload) {
      return service.post('/api/validate/initial-sync', context)
    },
    postDataUserProfile (context, payload) {
      return service.post('/api/profile/user/data', context, payload)
    }
  }
}

export default AuthenticationModule



// WEBPACK FOOTER //
// app/javascript/src/store/authentication.js